import Joi from 'joi';
import { rutValidation } from '../../../../../../helpers/RutValidator';
import { ocValidation } from '../../../../../../helpers/OcValidator';

export const schema = Joi.object({
  rut: rutValidation.rut().validateRut(),
  orderId: ocValidation.orderId().validateOc(),
  clientName: Joi.string()
    .min(3)
    .error(new Error('Debe ingresar su nombre completo.')),
  phone: Joi.string()
    .min(9)
    .max(9)
    .pattern(new RegExp(/^\d+$/))
    .error(new Error('El teléfono debe contener 9 dígitos.')),
  email: Joi.string()
    .pattern(
      new RegExp(/^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i),
    )
    .error(new Error('Formato de correo inválido.')),
  assembleAddress: Joi.string()
    .min(1)
    .max(200)
    .error(new Error('Debe ingresar una dirección de armado.')),
  comment: Joi.string()
    .allow(null, '')
    .max(250)
    .error(new Error('Máximo 250 caracteres.')),
});
